import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "rank-data-content" }
const _hoisted_2 = { class: "rank-data-title" }
const _hoisted_3 = { class: "rank-title" }


export default /*@__PURE__*/_defineComponent({
  __name: 'RankTable',
  props: {
    title: String, // 表格标题
    data: Array,   // 表格数据
    columns: Array, // 表格列配置    
},
  setup(__props) {

const props = __props;
    

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "rank-logo" }, null, -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1)
    ]),
    _createVNode(_component_el_table, {
      data: __props.data,
      border: "false",
      class: "no-border-table",
      style: _normalizeStyle({ width: _ctx.width || '650px' }),
      "header-cell-style": { backgroundColor: '#f5f5f5' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          label: "排名"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: index,
            prop: column.prop,
            label: column.label
          }, null, 8, ["prop", "label"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          prop: "total_amount",
          label: "销售额",
          width: "250px"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_progress, {
              percentage: scope.row.salesAmount / __props.data[0].salesAmount *100
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.salesAmount), 1)
              ]),
              _: 2
            }, 1032, ["percentage"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "style"])
  ]))
}
}

})